export default __webpack_public_path__ + "static/media/backArrow.fc60edc0.svg";